import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
const InsiderSideCartPage = withCompass(
  () => import("../../pages/InsiderSideCartPage")
);
const PrototypeStarterPage = withCompass(
  () => import("../../pages/PrototypeStarterPage")
);

export function AmyTalusRoutes() {
  return (
    <Switch>
      <Route path="/at/prototype-starter" component={PrototypeStarterPage} />
      <Route path="/at/insider-side-cart" component={InsiderSideCartPage} />
    </Switch>
  );
}

export const slug = "at";
